import { generateVariantData } from '../../../../experiments/utils';

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;
const curriculumImgURL = `${imgURL}/global/curriculum`;

const curriculumData = {
  title: 'Spark skills with our expert curriculum',
  subtitle: 'Increases computational thinking skills by 40%  after just 3 sessions',
  ctaLabel: 'Start 7-Day FREE Trial',
  curriculum: [
    {
      title: 'Sequencing',
      commandImage: `${curriculumImgURL}/sequencing_command.svg`,
      gameImage: `${curriculumImgURL}/sequencing_game_view.png`,
      fooImage: `${imgURL}/flagship/home-page/foo-card-gracie.png`,
      foo: 'Gracie',
      flipFoo: false,
      backgroundColor: '#2B6E2C',
      text:
        'The step-by-step order in which instructions should occur. Gracie uncovers mysterious cases around Fooville one step at a time.',
    },
    {
      title: 'Loops',
      commandImage: `${curriculumImgURL}/loops_command.svg`,
      gameImage: `${curriculumImgURL}/loops_game_view.png`,
      fooImage: `${imgURL}/flagship/home-page/foo-card-woz.png`,
      foo: 'Woz',
      flipFoo: true,
      backgroundColor: '#DB4F86',
      text:
        'A set of instructions that is repeated over and over again. A stickler for perfection, Woz is usually found restarting projects over and over and over.',
    },

    {
      title: 'Events',
      commandImage: `${curriculumImgURL}/events_command.svg`,
      gameImage: `${curriculumImgURL}/events_game_view.png`,
      fooImage: `${imgURL}/flagship/home-page/foo-card-val.png`,
      foo: 'Val',
      flipFoo: true,
      backgroundColor: '#7C39F9',
      text:
        'An action or cue that signals a new line of code to run. As an expert in space navigation, Val can handle any event thrown her way.',
    },
    {
      title: 'Conditional Statements',
      commandImage: `${curriculumImgURL}/conditional_statements_command.svg`,
      gameImage: `${curriculumImgURL}/conditional_statements_game_view.png`,
      fooImage: `${imgURL}/flagship/home-page/foo-card-sarge.png`,
      foo: 'Sarge',
      flipFoo: false,
      backgroundColor: '#4361ED',
      text:
        'Actions that execute based on certain provisions. IF a Foo craves a special meal, THEN Sarge is always ready to make it.',
    },
  ],
};

const variantToDataMapping = {
  homepageRefreshVariant1: {
    ...curriculumData,
    backgroundColor: '#F2F8FD',
  },
  homepageRefreshVariant2: {
    ...curriculumData,
    backgroundColor: '#FFFFFF',
  },
};

const DEFAULT_CONFIG_KEY = 'homepageRefreshVariant1';
export const getCurriculumVariantData = generateVariantData(
  variantToDataMapping,
  DEFAULT_CONFIG_KEY
);



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Curriculum/curriculumData.js